export default __webpack_public_path__ + "static/media/a8.b0c3caaf.png";